<template>
<div class="recommendDialog bgc" v-if="centerDialogVisible">
    <el-dialog title="推荐团长明细" :visible.sync="centerDialogVisible" width="800px">
        <div class="title">
            <div class="box">团长昵称：{{userinfo.headername}} <img :src="userinfo.headerlogourl" alt="" class="img"></div>
            <div class="box">直接上级：{{userinfo.recommendhostname}}</div>
        </div>
        <div class="title">
            <div class="box">推荐团长数量：{{userinfo.recommendheadercount}}</div>
            <div class="box">团长佣金：{{userinfo.brokeragerateheader.toFixed(2)}}%</div>
            <div class="box">推荐佣金：{{userinfo.brokerageraterecommend.toFixed(2)}}%</div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="orderno" label="团长名称">
                    <template slot-scope="scope">
                        <div class="imgtext">
                            <img :src="scope.row.headerlogourl" alt="" class="img">
                            <span>{{scope.row.headername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="linkman" label="联系人" width="80"></el-table-column>
                <el-table-column prop="linktel" label="联系电话" width="120"></el-table-column>
                <el-table-column prop="fanscount" label="粉丝数" width="80"></el-table-column>
                <el-table-column prop="brokeragerateheader" label="团长佣金" width="80">
                    <template slot-scope="scope">{{scope.row.brokeragerateheader.toFixed(2)}}%</template>
                </el-table-column>
                <el-table-column prop="brokerageraterecommend" label="推荐佣金" width="80">
                    <template slot-scope="scope">{{scope.row.brokerageraterecommend.toFixed(2)}}%</template>
                </el-table-column>
                <el-table-column prop="datetime" label="绑定时间" width="120"></el-table-column>
            </el-table>
            <dialogPage :total="total" @getList="_getList" ref="dialogPage"></dialogPage>
        </div>
    </el-dialog>
</div>
</template>

<script>
import {getRecommendedHeadDetails} from 'api/brandBusiness'
import {mapGetters, mapActions} from 'vuex'
import DialogPage from 'base/page/dialogPage'
export default {
    name: 'recommendDialog',
    data() {
        return {
            centerDialogVisible: false,
            param: {
                recommendhostid: '',
            },
            userinfo: {},
            tableData: [],
            total: 0
        }
    },
    mounted() {
    },
    methods: {
        openDialog(obj) {
            this.centerDialogVisible = true
            this.param.recommendhostid = obj.headerinnerid
            this.userinfo = obj
            this.tableData = []
            this.total = 0
            let dialogPage = {page: 1, pageSize: this.dialogPage.pageSize}
            this.$store.commit('SET_DIALOGPAGE', dialogPage)
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getRecommendedHeadDetails({
                data: Object.assign({}, this.param, this.dialogPage),
                success: data => {
                    this.setLoading(false)
                    this.total = data.data.pageinfo.datacount
                    this.tableData = data.data.recommendheaderlist
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'dialogPage'
        ])
    },
    components: {
        DialogPage
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.recommendDialog {
    .title{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 14px;
        margin-bottom: 20px;
        .box{
            display: flex;
            align-items: center;
            margin-right: 30px;
            .img{
                width: 50px;
                height: 50px;
                border-radius: 50%;
                margin-left: 10px;
            }
        }
    }
    .imgtext{
        display: flex;
        align-items: center;
        .img{
            width: 50px;
            height: 50px;
            border-radius: 50%;
            margin-right: 10px;
        }
    }
}
</style>
